<template>
  <!--
    	作者：gmshop
    	时间：2019-10-26
    	描述：商品管理-商品编辑-规格/库存-单规格
    -->
  <div>
    <el-form-item label="产品价格："  :rules="[{ required: true, message: '请填写产品价格' }]"  prop="model.sku.product_price">
      <!-- <el-input type="number" v-model="form.model.sku.product_price" class="max-w460"></el-input> -->
      <el-input type="number" min="0"  v-model="form.model.sku.product_price" class="max-w300">
        <template slot="append">
          元
        </template>
      </el-input>
    </el-form-item>
    <el-form-item label="积分价格："   prop="model.sku.points_price">
      <el-input  type="number" min="0"  v-model="form.model.sku.points_price" class="max-w300">
        <template slot="append">
          积分
        </template>
      </el-input>
       <div class="red">设置积分后，产品需要使用积分+现金一起支付，不能使用积分抵扣</div>
    </el-form-item>
    
    <el-form-item label="产品划线价：" prop="model.sku.line_price">
      <el-input type="number" v-model="form.model.sku.line_price" class="max-w460"></el-input>
     </el-form-item>
    <el-form-item label="库存数量：" :rules="[{ required: true, message: '请填写库存数量' }]" prop="model.sku.stock_num">
      <el-input type="number" v-model="form.model.sku.stock_num" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="商品重量(Kg)：" :rules="[{ required: true, message: '请填写商品重量' }]" prop="model.sku.product_weight">
      <el-input type="number" v-model="form.model.sku.product_weight" class="max-w460"></el-input>
    </el-form-item>
  </div>
</template>

<script>
  export default{
    inject: ['form']
  }
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/product/part/spec/Single.vue